import Vue from "vue";
import Vuex from "vuex";
import configModule from "./modules/config";
import authModule from "./modules/auth";
import userModule from "./modules/user";
import departmentModule from "./modules/department";
import roleModule from "./modules/role";
import permissionModule from "./modules/permission";
import diseasesHistoryModule from "./modules/diseases-history";
import checkupModule from "./modules/checkup";
import reportModule from "./modules/report";

import mentalHealthScheduleModule from "./modules/mental-health/schedule";
import mentalHealthRoomModule from "./modules/mental-health/room";
import mentalHealthPsychologistModule from "./modules/mental-health/psychologist";
import mentalHealthCheckupModule from "./modules/mental-health/checkup";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    config: configModule,
    auth: authModule,
    user: userModule,
    department: departmentModule,
    role: roleModule,
    permission: permissionModule,
    diseasesHistory: diseasesHistoryModule,
    checkup: checkupModule,
    report: reportModule,
    mentalHealth: {
      namespaced: true,
      modules: {
        schedule: mentalHealthScheduleModule,
        room: mentalHealthRoomModule,
        psychologist: mentalHealthPsychologistModule,
        checkup: mentalHealthCheckupModule,
      },
    },
  },
});
